<script>
import { nextTick } from 'vue'

import Table from './SortedTable.vue'

export default {
    name: 'TableForm',
    
    components: {
        Table
    },

    props: {
        headers: {
            type: Array,
            default: () => []
        },
        rows: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        }
    },

    emits: ['form-closed'],

    data() {
        return {
        }
    },

    async mounted() {
        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        }
    }
}
</script>

<template>
    <div class="form table-form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ title }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10">                    
                    <div class="scrollable">
                        <Table :headers="headers" :rows="rows" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>